/**
* @internal
* Used to set `extensions` on the GraphQL result without exposing it
* unnecessarily. Only use internally!
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
export const extensionsSymbol = Symbol.for("apollo.result.extensions");
/**
 * For use in Cache implementations only.
 * This should not be used in userland code.
 */
export const streamInfoSymbol = Symbol.for("apollo.result.streamInfo");
/**
* @internal
* Used as key for `ApolloClient.WatchQueryOptions`.
*
* Meant for framework integrators only!
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
export const variablesUnknownSymbol = Symbol.for("apollo.observableQuery.variablesUnknown");
//# sourceMappingURL=constants.js.map
